<template>
  <div class="current-widget">
    <div class='main_header'>
      <div class="big">
        <span>{{$t(`widgets.subscription.title_big`)}}</span>
      </div>
    </div>
    <div class="chart-content">
      <BarChart :chart-data="dataCollection" :options="chartOptions" class="chart-style"></BarChart>
    </div>
    <div class="data-content">
      <ChartDescriptionItem v-for="(item, index) in dataKeys.data"
        :iconColor="item.color"
        :text="item.keyAlias"
        :key="index"
        :value="item.value"
        :percent="item.percent"
      ></ChartDescriptionItem>
    </div>
  </div>
</template>

<script>

  import {rest, initCurrentUser} from '../../api'
  import DefaultContainerScroll from '../../component/DefaultContainerScroll'
  import {BFormInput} from 'bootstrap-vue'
  import BarChart from '../chart/BarChart'
  import VerticalLineChartItem from '../widget/util/VerticalLineChartItem'
  import ChartDescriptionItem from '../widget/util/ChartDescriptionItem'
  import {common} from '../../mixin/mixin.js'

  export default {
    name: 'SubscriptionWidget',
    mixins: [common],
    components: {BFormInput, DefaultContainerScroll, BarChart, ChartDescriptionItem, VerticalLineChartItem},
    props: {
      name: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        totalCount: 0,
        labelsData: {},
        dataKeys: {},
        dataCollection: {},
        chartOptions: {}
      }
    },
    mounted() {
      this.chartOptions = {
          barRoundness: 10,
          tooltips: {
            backgroundColor: '#fff',
            titleFontColor: '#555',
            bodyFontColor: '#555',
            footerFontColor: '#555',
            borderWidth: 1,
            borderColor: '#00000033',
            fontColor: 'red'
          },
          responsive: true,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                lineWidth: 1,
                color: this.getColor('axis_color'),
                zeroLineColor: this.getColor('axis_color')
              },
              scaleLabel: {
                display: true,
                labelString: this.$t('widgets.subscription.x_label')
              },
              ticks: {
                autoSkip: false,
                //  min: 1,
                // max: 31,
                stepSize: 1,
                // fixedStepSize: 1,
                maxRotation: 0,
                minRotation: 0,
                padding: -3,
                //    showLabelBackdrop: false,
                beginAtZero: true,
                fontSize: 9,
                fontColor: this.getColor('scale_color')
              }
            }],

            yAxes: [{
              gridLines: {
                lineWidth: 1,
                drawBorder: false,
                color: this.getColor('axis_color'),
                zeroLineColor: this.getColor('axis_color')
              },
              scaleLabel: {
                display: true,
                labelString: this.$t('widgets.subscription.y_label')
              },
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                padding: 0,
                beginAtZero: true,
                stepSize: 2,
                min: 0,
                fontSize: 9,
                fontColor: this.getColor('scale_color')
              }
            }]
          }
      }
      this.fetchData()
    },
    methods: {
      initData() {
        this.totalCount = 0
        this.labelsData = {data: [
            {key: 1,  keyAlias: '>4',  startValue: 4,    endValue: null,  value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 2,  keyAlias: '3.5', startValue: 3.5,  endValue: 4,     value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 3,  keyAlias: '3',   startValue: 3,    endValue: 3.5,   value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 4,  keyAlias: '2.5', startValue: 2.5,  endValue: 3,     value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 5,  keyAlias: '2',   startValue: 2,    endValue: 2.5,   value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 6,  keyAlias: '1.5', startValue: 1.5,  endValue: 2,     value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 7,  keyAlias: '1',   startValue: 1,    endValue: 1.5,   value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 8,  keyAlias: '0.5', startValue: 0.5,  endValue: 1,     value: 0, percent: 0, color: this.getColor('yellow_color')},
            {key: 9,  keyAlias: '>0',  startValue: 0.1,  endValue: 0.5,   value: 0, percent: 0, color: this.getColor('yellow_color')},
            {key: 10, keyAlias: '<=0', startValue: null, endValue: 0.1,   value: 0, percent: 0, color: this.getColor('red_color')}
          ]}
        this.dataKeys = {data: [
            {key: 1,  keyAlias: this.$t('widgets.subscription.description_good'),  startValue: 1,    endValue: null,  value: 0, percent: 0, color: this.getColor('green_color')},
            {key: 8,  keyAlias: this.$t('widgets.subscription.description_medium'),     startValue: 0.1,  endValue: 1,     value: 0, percent: 0, color: this.getColor('yellow_color')},
            {key: 10, keyAlias: this.$t('widgets.subscription.description_bad'),          startValue: null, endValue: 0.1,   value: 0, percent: 0, color: this.getColor('red_color')}
          ]}
      },
      fetchData() {
        this.initData()
        rest.get('/widget/subscription', this.getParamsForGroupFilter()).then(response => {
          this.dataCollection.datasets = []
          this.dataCollection.labels = []
          const values = []

          for (const dataItem of response.data) {
            const yearsCount = Math.round((dataItem.monthCount / 12) * 10) / 10
            for (const labelsData of this.labelsData.data) {

              if (labelsData.startValue) {
                if (labelsData.endValue) {
                  if (yearsCount >= labelsData.startValue && yearsCount < labelsData.endValue) {
                    labelsData.value += dataItem.count
                    break
                  }
                } else {
                  if (yearsCount >= labelsData.startValue) {
                    labelsData.value += dataItem.count
                    break
                  }
                }
              } else {
                if (yearsCount < labelsData.endValue) {
                  labelsData.value += dataItem.count
                  break
                }
              }
            }
          }

          for (const item of this.labelsData.data) {
            item.percent = Math.round(item.value / this.labelsData.data.map(i => i.value).reduce((val1, val2) => val1 + val2) * 100)
          }

          for (const dataItem of response.data) {
            const yearsCount = Math.round((dataItem.monthCount / 12) * 10) / 10
            for (const labelsData of this.dataKeys.data) {

              if (labelsData.startValue) {
                if (labelsData.endValue) {
                  if (yearsCount >= labelsData.startValue && yearsCount < labelsData.endValue) {
                    labelsData.value += dataItem.count
                    break
                  }
                } else {
                  if (yearsCount >= labelsData.startValue) {
                    labelsData.value += dataItem.count
                    break
                  }
                }
              } else {
                if (yearsCount < labelsData.endValue) {
                  labelsData.value += dataItem.count
                  break
                }
              }
            }
          }

          for (const item of this.dataKeys.data) {
            item.percent = Math.round(item.value / this.dataKeys.data.map(i => i.value).reduce((val1, val2) => val1 + val2) * 100)
          }

          this.dataCollection = {
            labels: this.labelsData.data.map(item => item.keyAlias),
            datasets: [
              {
                backgroundColor: this.labelsData.data.map(item => item.color),
                data: this.labelsData.data.map(item => item.value)
              }
            ]
          }
        })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  /* Custom Styles */
  @import "../../assets/scss/main";

  .current-widget {
    width: 100%;
    height: 100%;
  }

  .main_header {
    display: inline;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    line-height: get-size(24);
  }
  .big {
    display: inline-block;
    width:80%;
    font-size: get-size(22);
    text-align: left;
  }
  .small {
    display: inline-block;
    width:20%;
    font-size: get-size(14);
    text-align: right;
  }

  .chart-content {
    margin-top: get-size(15);
    width: 100%;
    margin-bottom: get-size(20);
  }

  .data-content {
    padding-top: get-size(20);
  }

  .chart-style {
    border-radius: get-size(10);
  }
</style>
